import SqFetch from 'typescript/application/sq_fetch';
import { _urlContext } from 'typescript/clients/utilities/common';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';
import { ShippingRate } from 'typescript/types/api/shipping_rates';

const SHIPPING_RATES_BASE_URL = '/shop/api/v1/checkout/shipping_rates';
export const GET_SHIPPING_RATES_URL = `${SHIPPING_RATES_BASE_URL}/list`;
export const SELECT_SHIPPING_RATE_URL = `${SHIPPING_RATES_BASE_URL}/update`;

/**
 * Get shipping rates
 * @param orderNumber - order number
 * @param countryCode - country code
 * @param languageCode - language code
 * @returns an array of shipping rate objects
 */
export const getShippingRates = async ({
  orderNumber,
  countryCode,
  languageCode,
}: {
  orderNumber: string;
  countryCode: CountryCode;
  languageCode: LanguageCode;
}): Promise<ShippingRate[]> => {
  const response = await SqFetch.get(
    `${GET_SHIPPING_RATES_URL}${_urlContext({
      countryCode,
      languageCode,
      orderNumber,
    })}`,
  );

  return _handleResponse(response);
};

/**
 * Select shipping rate
 * @param orderNumber - order number
 * @param countryCode - country code
 * @param languageCode - language code
 * @param shippingRateCode - shipping rate code (service level, e.g., 'standard', 'two_day')
 * @returns an array of updated shipping rate objects
 */
export const selectShippingRate = async ({
  orderNumber,
  countryCode,
  languageCode,
  shippingRateCode,
}: {
  orderNumber: string;
  countryCode: CountryCode;
  languageCode: LanguageCode;
  shippingRateCode: string;
}): Promise<ShippingRate[]> => {
  const response = await SqFetch.post(SELECT_SHIPPING_RATE_URL, {
    shipping_rate_code: shippingRateCode,
    store_code: countryCode,
    language_code: languageCode,
    order_number: orderNumber,
  });

  return _handleResponse(response);
};
